module.exports = __webpack_public_path__ + "media/public/img/google-ttd-0cb2e6cb00505e922c7ce01f39bd9249.png";